import {BRAND_KEY} from '../../../brand'
import {remCalc} from '../../_utils'
import getSemantics from '../../semantics'
import {Responsive} from '../../types/semantics.types'

export default {
    baseStyle: () => {
        const remCalc6 = remCalc(6)

        const semantics = getSemantics(BRAND_KEY)

        const primaryButtonColor = semantics.colors.button.background['primary-default']
        const primaryButtonColorText = semantics.colors.button.text['primary-default']
        const primaryButtonColorHover = semantics.colors.button.background['primary-hover']
        const primaryButtonColorTextHover = semantics.colors.button.text['primary-hover']
        const buttonRadius = (semantics.radii.button.radius['primary-default'] as Responsive)?.base
        const primaryTextColor = semantics.colors.button.text['text-default']

        return {
            '.chakra-ui-light': {
                '.gigya-password-strength-bubble .gig-balloon-frame': {
                    background: 'white',
                    border: 0, //'small',
                    // borderStyle: 'solid',
                    // borderColor: 'border.light',
                    borderRadius: remCalc(2),
                    boxShadow: `0 0 ${remCalc6} 0 rgba(0, 0, 0, 0.15)`,
                    padding: remCalc(16),
                },
                '.gigya-password-strength-bubble .gig-balloon-nub, .gigya-password-strength-bubble .gig-balloon-nub-up, .gigya-password-strength-bubble .gig-balloon-nub-right, .gigya-password-strength-bubble .gig-balloon-nub-down':
                    {
                        filter: 'contrast(200%) brightness(150%)',
                        marginLeft: 'calc(50% - 16px)',
                    },
                '.gigya-password-strength-bubble .gig-balloon-frame .gigya-passwordStrength-bar': {
                    display: 'none',
                },
                '.gigya-passwordStrength-text:not(.gigya-passwordStrength-text .gigya-passwordStrength-text)':
                    {
                        paddingBottom: remCalc(8),
                    },
                '.gigya-passwordStrength-text, div.gigya-passwordStrength-text-requirements': {
                    textAlign: 'left',
                },
                'span.gigya-passwordStrength-scoreText': {
                    marginLeft: 0,
                },
                '.gigya-style-modern #gigya-screen-dialog-page-overlay': {
                    opacity: 0.75,
                },
                '.gigya-screen-dialog.gigya-style-modern, .gigya-screen-dialog-mobile.gigya-style-modern':
                    {
                        width: '100%',
                        left: '0 !important',
                        display: 'flex',
                        justifyContent: 'center',
                    },
                '.gigya-screen-dialog-mobile.gigya-style-modern': {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    zIndex: 1000,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch', // better scroll on iOS
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '20px 0',
                    boxSizing: 'border-box',
                },
                '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-main, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-main':
                    {
                        width: '94%',
                        maxWidth: remCalc(688),
                        padding: `${remCalc(24)} ${remCalc(16)}`,
                        background: '#ffffff',
                        borderRadius: remCalc(8),
                        textStyle: 'body-medium',
                        boxShadow: 'none',
                    },
                '.gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-main': {
                    // to avoid shrink when virtal keyboard is open on mobile
                    flexShrink: 0,
                },
                '.gigya-screen-dialog.gigya-style-modern .dlg-screen-dialog-main .gigya-screen-dialog-top, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-screen-dialog-main .gigya-screen-dialog-top':
                    {
                        display: 'none',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-top, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-top':
                    {
                        padding: `0 0 ${remCalc(16)}`,
                        background: '#ffffff',
                        borderBottom: `${remCalc(1)} solid #000000`,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: remCalc(24),
                    },
                '.gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-top': {
                    position: 'relative',
                },
                '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-top .gigya-screen-dialog-caption, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-top .gigya-screen-dialog-caption':
                    {
                        color: '#000000',
                        fontSize: remCalc(18),
                        lineHeight: remCalc(22),
                        fontFamily: 'inherit',
                    },
                '.gigya-style-modern div.gigya-screen-dialog-close > a': {
                    display: 'flex',
                    padding: remCalc(0),
                },
                '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-inner .gigya-screen-content form, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-inner .gigya-screen-content form':
                    {
                        paddingTop: 0,
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-inner .gigya-screen-content form>.gigya-layout-row, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-screen-dialog-inner .gigya-screen-content form>.gigya-layout-row':
                    {
                        display: 'flex',
                        flexDirection: 'column',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-label-text.gigya-composite-control, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-label-text.gigya-composite-control':
                    {
                        paddingBottom: remCalc(24),
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-composite-control, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-composite-control':
                    {
                        position: 'relative',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper input, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper input':
                    {
                        borderRadius: `${remCalc(4)} !important`,
                        border: `${remCalc(1)} solid #636363 !important`,
                        color: '#000000',
                        fontSize: remCalc(12),
                        outline: '0',
                        width: '100%',
                        lineHeight: remCalc(16),
                        backgroundColor: 'transparent !important',
                        padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                        boxSizing: 'border-box',
                        appearance: 'none',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper>label':
                    {
                        lineHeight: '150%',
                        display: 'inline-block',
                        color: '#636363',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        transformOrigin: '0 0',
                        transition:
                            'top .4s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1), color .4s cubic-bezier(.25,.8,.25,1), width .4s cubic-bezier(.25,.8,.25,1)',
                        padding: `0 ${remCalc(4)}`,
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        position: 'absolute',
                        top: `calc(50% - ${remCalc(21)})`,
                        left: remCalc(8),
                        zIndex: '1',
                        fontSize: remCalc(12),
                        backgroundColor: 'transparent',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.focus-visible)>label, .gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.gigya-valid)>label, .gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.gigya-error)>label, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.focus-visible)>label, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.gigya-valid)>label, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.gigya-error)>label':
                    {
                        backgroundColor: '#ffffff',
                        transform: 'translateY(calc(50% - 23px)) scale(.75)',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label .gigya-label-text, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper>label .gigya-label-text':
                    {
                        color: '#636363',
                        fontSize: remCalc(14),
                        lineHeight: remCalc(16),
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-error-msg, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-error-msg':
                    {
                        minHeight: remCalc(24),
                        color: '#DE1C2F',
                        textAlign: 'left',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper input.gigya-error, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper input.gigya-error':
                    {
                        padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                        border: `${remCalc(1)} solid #DE1C2F !important`,
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label:has(~ .gigya-error), .gigya-screen-dialog-mobile.gigya-style-modern .dlg-gigya-input-text-wrapper>label:has(~ .gigya-error), .gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label:has(~ .gigya-error) *':
                    {
                        color: '#DE1C2F',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dlg-hidden, .gigya-screen-dialog.gigya-style-modern .gigya-toggle-content, .gigya-screen-dialog-mobile.gigya-style-modern .dlg-hidden, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-toggle-content':
                    {
                        display: 'none',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dln-completeForm__paragraph--secondary, .gigya-screen-dialog-mobile.gigya-style-modern .dln-completeForm__paragraph--secondary':
                    {
                        fontSize: remCalc(14),
                        color: '#636363',
                        lineHeight: '125%',
                        marginBottom: remCalc(24),
                        display: 'inline-block',
                    },
                '.gigya-screen-dialog.gigya-style-modern .dln-completeForm__paragraph a, .gigya-screen-dialog.gigya-style-modern .gigya-checkbox-text a, .gigya-screen-dialog-mobile.gigya-style-modern .dln-completeForm__paragraph a, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-checkbox-text a':
                    {
                        textDecoration: 'underline',
                        color: '#000000',
                        fontWeight: 'medium',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-submit, .gigya-screen-dialog.gigya-style-modern .gigya-button-link, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-submit, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-button-link':
                    {
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        outlineWidth: 0,
                        fontSize: remCalc(16),
                        lineHeight: remCalc(20),
                        fontWeight: 'bold',
                        alignItems: 'center',
                        height: remCalc(40),
                        background: primaryButtonColor,
                        borderRadius: buttonRadius,
                        color: primaryButtonColorText,
                        cursor: 'pointer',
                        marginTop: remCalc(24),
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-button-link button, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-button-link button':
                    {
                        fontWeight: 'bold',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-submit:hover, .gigya-screen-dialog.gigya-style-modern .gigya-button-link:hover, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-submit:hover, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-button-link:hover':
                    {
                        background: primaryButtonColorHover,
                        color: primaryButtonColorTextHover,
                        border: `${remCalc(1)} solid ${primaryButtonColor}`,
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox+label.gigya-label:before, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-checkbox+label.gigya-label:before':
                    {
                        content: '""',
                        position: 'absolute',
                        display: 'block',
                        top: 0,
                        left: 0,
                        width: remCalc(24),
                        height: remCalc(24),
                        border: `${remCalc(1)} solid #000000`,
                        backgroundColor: 'transparent',
                        borderRadius: remCalc(2),
                        zIndex: 1,
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox+label.gigya-label:after, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-checkbox+label.gigya-label:after':
                    {
                        content: '""',
                        position: 'absolute',
                        display: 'none', // Nascosta di default
                        top: remCalc(3),
                        left: remCalc(9),
                        width: remCalc(7),
                        height: remCalc(15),
                        border: `solid #000000`,
                        borderWidth: `0 ${remCalc(2)} ${remCalc(2)} 0`,
                        transform: 'rotate(45deg)',
                        zIndex: 2,
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox:checked+label.gigya-label:after, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-checkbox:checked+label.gigya-label:after':
                    {
                        display: 'block',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox+label.gigya-label, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-checkbox+label.gigya-label':
                    {
                        position: 'relative',
                        display: 'block',
                        cursor: 'pointer',
                        paddingLeft: remCalc(40),
                        minHeight: remCalc(24),
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-input-checkbox':
                    {
                        position: 'absolute',
                        opacity: 0,
                        width: '1px',
                        height: '1px',
                        margin: '-1px',
                        padding: 0,
                        overflow: 'hidden',
                        clip: 'rect(0, 0, 0, 0)',
                        border: 0,
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-composite-control-checkbox .gigya-checkbox-text':
                    {
                        fontSize: remCalc(14),
                        lineHeight: remCalc(16),
                        fontWeight: 'normal',
                        display: 'block',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-resend-verification-code-form .gigya-spacer, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-resend-verification-code-form .gigya-spacer':
                    {
                        display: 'none',
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-resend-verification-code-form .gigya-composite-control-submit input, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-resend-verification-code-form .gigya-composite-control-submit input':
                    {
                        marginTop: 0,
                    },
                '.gigya-screen-dialog.gigya-style-modern .gigya-resend-verification-code-form .gigya-composite-control-link, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-resend-verification-code-form .gigya-composite-control-link':
                    {
                        marginTop: remCalc(24),
                        fontWeight: 'bold',
                        textAlign: 'center',
                        color: primaryTextColor,
                        textDecoration: 'underline',
                    },
                '@media (min-width: 1024px)': {
                    '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-main': {
                        padding: `${remCalc(40)} ${remCalc(24)}`,
                    },
                },
                '.gigya-screen-dialog.gigya-style-modern .gigya-composite-control-checkbox .gigya-checkbox-text button.dln-icn.dln-icn--iconfont, .gigya-screen-dialog-mobile.gigya-style-modern .gigya-composite-control-checkbox .gigya-checkbox-text button.dln-icn.dln-icn--iconfont':
                    {
                        display: 'none',
                    },
            },
        }
    },
}
